// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersPrevious = props => (
	<OrdersOverview {...props} orderFlowType='orders_previous' />
);
export default OrdersPrevious;
